export default __webpack_public_path__ + "static/media/house2.2a16dfb0.png";